/* eslint-disable @typescript-eslint/ban-types */ import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { parseQueryParams } from "@faire/web--source/common/query-params/parseQueryParams";
import compact from "lodash/compact";
import flatten from "lodash/flatten";
import forEach from "lodash/forEach";
export var Path = function Path(param) {
    "use strict";
    var _this = this;
    var pathname = param.pathname, search = param.search;
    _class_call_check(this, Path);
    this.delete = function(paramNames) {
        if (typeof paramNames === "string") {
            // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
            delete _this.searchParams.values[paramNames];
        } else {
            paramNames.forEach(function(name) {
                // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
                delete _this.searchParams.values[name];
            });
        }
        return _this;
    };
    this.append = function(params) {
        forEach(params, function(value, key) {
            if (value === undefined) {
                return;
            }
            // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
            var curValue = _this.searchParams[key];
            // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
            _this.searchParams.values[key] = curValue ? _to_consumable_array(flatten([
                curValue
            ])).concat(_to_consumable_array(flatten([
                value
            ]))) : value;
        });
        return _this;
    };
    this.replace = function(params) {
        forEach(params, function(value, key) {
            if (value === undefined) {
                return;
            }
            // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
            _this.searchParams.values[key] = value;
        });
        return _this;
    };
    this.toString = function() {
        return compact([
            _this.pathname,
            _this.searchParams.toString()
        ]).join("?");
    };
    this.pathname = pathname;
    this.searchParams = parseQueryParams(search);
};
Path.getFirstSearchParam = function(query) {
    if (!query) {
        return undefined;
    }
    return Array.isArray(query) ? query[0] : query;
};
/**
 * @deprecated use getCurrentPath
 */ export var currentPath = function() {
    return getCurrentPath();
};
export var getCurrentPath = function() {
    var window = getWindow();
    if (!window) {
        throw new Error("Cannot resolve path without window.location");
    }
    return new Path(window.location);
};
